import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
    Button,
  Comment,
  CommentAction,
  CommentActions,
  CommentGroup,
  CommentMetadata,
  CommentText,
  Container,
  Form,
  FormField,
  Header,
  Input,
  Label,
  Loader,
  Message,
  Segment,
  SegmentGroup,
} from "semantic-ui-react";
import "./HomePage.css";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import './Banner.css'
import { getAllAnnouncements, setAddAnnoucement, setDeleteAnnouncement } from "../queries.jsx";
import { getCurrentTimestamp } from "../TimeStamp.jsx";
import { readFromToken, UserRoles } from "../auth.ts";
import { useAppContext } from "../AppContext.jsx";
import TextAndIcon from "../TextAndIcon.jsx";
import { useLocation } from "react-router-dom";

const Banner = ({ mobile, hide }) => {
    const { t, i18n } = useTranslation();

    const { rtl } = useAppContext();

    const [postInput, setPostInput] = useState('');
    const [inputHasError, setInputHasError] = useState(false);

    const onInputChange = (value) => {
        setInputHasError(false);
        setPostInput(value);
    }

    const {
        data: allAnnouncementsData,
        error, 
        isLoading,
        refetch: refetchAnnoucements,
    } = useQuery("getAllAnnouncements", getAllAnnouncements,  {
        enabled: !hide,
    });
  

    const setAddAnnoucementMutation = useMutation(setAddAnnoucement, {
        onSettled: (response) => { refetchAnnoucements(); }
    });

    const setDeleteAnnoucementMutation = useMutation(setDeleteAnnouncement, {
        onSettled: (response) => { refetchAnnoucements(); }
    });

    const onPostAnnoucement = () => {
        if (!postInput) {
            setInputHasError(true);
            return;
        }
        setAddAnnoucementMutation.mutate({ post_time: getCurrentTimestamp(), body: postInput })
        setPostInput("");
        console.log("removed");
    }

    const onDeleteAnnoucement = (id) => {
        setDeleteAnnoucementMutation.mutate({ id })
    }

    const getTimeMinusTwoHours = (time) => {
        const d = new Date(time);
        d.setHours(d.getHours()-2);
        return d;

    }

    const hasAnnoucements = allAnnouncementsData && allAnnouncementsData.length;
    const slidesPerPage = 2;
    const isClinicUser = readFromToken('role') === UserRoles.AUTHORIZED_DOCTOR;
    const isSignedIn = !!readFromToken('email');
    const { pathname } = useLocation();

    if (hide) return <></>;

    return (
      <Container className="banner-container" text textAlign="center" style={{ minHeight: (!mobile && isClinicUser) ? '350px' : (!mobile && !isClinicUser) ? ( pathname === '/schedule' ? '300px' : '350px' ) : 'none' }}>
        <div>
            <Header
                as="h2"
                content={(
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {t('ramot-clinic')}
                        <br />
                        <a href="https://wa.me/972523006756" target="_blank" rel="noreferrer">
                            <TextAndIcon icon="whatsapp" text="052-3006756"/>
                        </a>
                    </div>
                )}
                // inverted
                style={{
                    fontSize: mobile ? "2.5em" : "3em",
                    marginBottom: 0,
                    marginTop: "0.5em",
                    color: "#1d2c62",
                    fontWeight: 600,
                }}
            />
            { !isClinicUser && pathname !== '/schedule' && ( 
                <>
                    <Button as='a' href={isSignedIn ? '/schedule' : '/signin'} color='blue' size="medium">{t("schedule-appointment")}</Button>
                    <br /><br />
                </>
            )}
            <SegmentGroup raised className="annoucements-segment-group">
            <Segment style={{ minHeight: '100px', padding: hasAnnoucements ? '30px 50px' : '20px' }}>
                <Label color='blue' ribbon floating style={{ left: '4px' }}>
                    {t('latest-announcements')}
                </Label>
                { isLoading ? (
                    <Loader />
                ) : hasAnnoucements ? (
                    <Slider
                        dots
                        infinite={allAnnouncementsData.length > slidesPerPage}
                        speed={1000}
                        slidesToShow={slidesPerPage}
                        slidesToScroll={slidesPerPage}
                        initialSlide={0}
                        autoplay
                        autoplaySpeed={5000}
                        swipeToSlide
                    >
                        { allAnnouncementsData.map(({ body, post_time, id }) => (
                            <CommentGroup>
                                <Comment>
                                    <CommentText>{body}</CommentText>
                                    <CommentActions>
                                        <CommentMetadata style={{ direction: rtl ? 'rtl' : 'ltr' }}>
                                            {getTimeMinusTwoHours(post_time).toLocaleString(i18n.language, { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', hourCycle: 'h24', minute: 'numeric' })}
                                        </CommentMetadata>
                                        {
                                            isClinicUser && (
                                                <CommentAction style={{ fontSize: '0.95em' }} as="a" onClick={() => onDeleteAnnoucement(id)}>{t('delete-announcement')}</CommentAction>
                                            )
                                        }
                                    </CommentActions>
                                </Comment>
                            </CommentGroup>
                        )) }
                    </Slider>
                ) : (
                    <Message
                        icon='announcement'
                        info
                        header={t('no-announcement-header')}
                    />
                )}
            </Segment>
            { isClinicUser && (
                <Segment>
                    <Form>
                        <FormField inline error={inputHasError} style={{ display: 'flex' }}>
                            <Input error={inputHasError} value = {postInput} onChange={(_, { value }) => onInputChange(value)} type='text' placeholder={t('post-announcement-placeholder')} style={{ flexGrow: '1' }} />
                            {/* <TextArea onChange={(_, { value }) => setPostInput(value)} rows={2} style={{ min: 300 }} /> */}
                            <Button onClick={() => onPostAnnoucement()} color="blue">{t('post-announcement')}</Button>
                        </FormField>
                    </Form>
                </Segment>
            )}
            </SegmentGroup>
        </div>
    </Container>
    );
};

export default Banner;